export default __webpack_public_path__ + "static/media/ShibariumDAO.8128b93a.png";